import React, { useRef, useImperativeHandle, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { IFModal } from 'Components'
import PropTypes from 'prop-types'
import OperatorAlertDetails from './OperatorAlertDetails'

const OperatorAlertModal = React.forwardRef(
  ({ setClickedOperatorAlert, isNew, onDismiss }, ref) => {
    const { t } = useTranslation()
    const modalRef = useRef()
    const [sessionKey, setSessionKey] = useState(0)

    const customDialogContentStyle = {
      height: '42.5rem',
      width: '56.25rem',
    }

    const show = (rowData) => {
      setSessionKey((k) => k + 1)
      if (rowData) setClickedOperatorAlert(rowData)
      modalRef.current.show()
    }

    const handleDismiss = () => {
      onDismiss?.()

      if (!isNew) setClickedOperatorAlert({})
    }

    const dismiss = () => {
      handleDismiss()
      modalRef.current.dismiss()
    }

    useImperativeHandle(ref, () => ({ show, dismiss }))

    return (
      <IFModal
        title={t('OperatorAlertList.OperatorAlertDetails')}
        ref={modalRef}
        maxWidth={60}
        dialogContentStyle={customDialogContentStyle}
        onDismiss={handleDismiss}
      >
        <OperatorAlertDetails
          key={`${isNew ? 'new' : 'edit'}-${sessionKey}`}
          isNew={isNew}
        />
      </IFModal>
    )
  },
)

OperatorAlertModal.propTypes = {
  setClickedOperatorAlert: PropTypes.func.isRequired,
  isNew: PropTypes.bool,
  onDismiss: PropTypes.func,
}

OperatorAlertModal.defaultProps = {
  isNew: false,
  onDismiss: undefined,
}

export default OperatorAlertModal
